import pubsub from "pubsub-js";
import store from "@/store/index";

import { mapState } from 'vuex';
import { getPaperCollectionList, getMathLevel, showTopicNames } from "@/api/chat/sendReceive";
import { showGraphNames } from "@/api/chat/knowledgeGraph";
import { getLevel, getRobotByLevel } from '@/utils/chat/chatUtil';
import { showTopic } from "../api/chat/sendReceive";


export default {
    computed: {
        ...mapState([
            // 这里可以添加你从 store 中获取的状态
            "messageStorage",
            "foldHistory",
            "robotSessionMap",
            "foldRobot",
            "isMobile",
            "papers",
            "robotId",
            "level"

        ])
    },
    data() {
        return {
            graphs: [],
            topics: [],
            paperShow: false,
            graphShow: false,
            topicShow: false,
            score: "",

        };
    },
    methods: {
        // 公共方法
        showPaper(paper) {
            let sessionId = this.robotSessionMap.composition;
            if (!sessionId) sessionId = +new Date() + "";
            this.$router.push(`/chatSearch/composition/${sessionId.slice(-10)}`);
            pubsub.publish("getPaper", { paper });
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT")
                this.$emit("hideCollect")
            }
        },
        showGraph({ kgid, level }) {
            let currentRobotId = getRobotByLevel(level);
            let sessionId = this.robotSessionMap[currentRobotId];
            if (!sessionId) sessionId = +new Date() + "";
            this.$router.push(`/chatSearch/${currentRobotId}/${sessionId.slice(-10)}`);
            pubsub.publish("getGraph", { kgid, level });
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT")
                this.$emit("hideCollect")
            }
        },
        // 展示某个专题
        showTopic(topic) {
            let { level } = topic
            let currentRobotId = getRobotByLevel(level);
            let sessionId = this.robotSessionMap[currentRobotId];
            if (!sessionId) sessionId = +new Date() + "";
            this.$router.push(`/chatSearch/${currentRobotId}/${sessionId.slice(-10)}`);
            pubsub.publish("getTopic", topic);
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT")
                this.$emit("hideCollect")
            }
        },
        // 试题收藏列表
        async getPaperCollectionNames() {
            let res = await getPaperCollectionList(); // 对应 showPaperNames
            if (!res || !res.data) return;
            // 直接存储后端返回的完整对象，不做任何转换
            store.commit("setPapers", res.data.papernames);
        },
        // 图谱收藏列表
        async getGraphCollectionNames() {
            this.graphs = [];
            let { data: res } = await showGraphNames();
            if (!res) return;
            if (res.kgnames.length < 1) return
            this.graphs = res.kgnames.map((item) => {
                return {
                    kgid: item[0],
                    level: item[1]
                }
            })

        },

        // 专题收藏列表
        async getTopicCollectionNames() {
            this.topics = [];
            let { data: res } = await showTopicNames();
            if (!res) return;
            if (res.topicnames.length < 1) return
            this.topics = res.topicnames.map((item) => {
                return {
                    title: item[0],
                    level: item[1]
                }
            })

        },

        async getScore() {
            if (this.foldRobot && this.score !== "" && !this.isMobile) return
            this.score = "";
            let { data: res } = await getMathLevel();
            if (!res) return;
            this.score = res.mathlevel;
        },
        async choosedRobot(robotId) {
            if (robotId === "collect") {
                if (this.foldRobot) {
                    store.commit("SET_FOLDROBOT", !this.foldRobot);
                    this.showCollect = true;
                    return
                } else {
                    this.showCollect = !this.showCollect;
                }
                return;
            } else if (robotId === "mathLevel") {
                if (this.foldRobot && !this.isMobile) {
                    store.commit("SET_FOLDROBOT", !this.foldRobot);
                }
                await this.getScore();

                return;
            }
            // 默认打开上次在这个智能体的对话
            let sessionId = this.robotSessionMap[robotId];
            if (!sessionId) sessionId = +new Date() + "";
            if (["mexercises", "exercises","pexercises","composition"].includes(robotId)) {
                this.$router.push(`/chatSearch/${robotId}/${sessionId.slice(-10)}`);
            } else {
                if ("paperCollect" === robotId) {
                    this.paperShow = !this.paperShow;
                    if (!this.paperShow) return;
                    this.graphShow = false;
                    this.topicShow = false;
                    await this.getPaperCollectionNames();
                    return;
                } else if ("graphCollect" === robotId) {
                    this.graphShow = !this.graphShow;
                    if (!this.graphShow) return;
                    this.paperShow = false;
                    this.topicShow = false;
                    await this.getGraphCollectionNames();
                    return;
                } else if ("topicCollect" === robotId) {
                    this.topicShow = !this.topicShow;
                    if (!this.topicShow) return;
                    this.graphShow = false;
                    this.paperShow = false;
                    await this.getTopicCollectionNames();
                    return
                } else {
                    let currentRobotId = this.robotId
                    let level = getLevel();
                    if (level === 'm') {
                        currentRobotId = "mexercises"

                    } else {
                        currentRobotId = "exercises"
                    }

                    if (robotId === 'knowledgeGraph') {
                        currentRobotId = 'exercises'
                    }
                    let sessionId = this.robotSessionMap[currentRobotId];
                    if (!sessionId) sessionId = +new Date() + "";
                    this.$router.push(`/chatSearch/${currentRobotId}/${sessionId.slice(-10)}`);
                }
                if (this.isMobile) {
                    store.commit("SET_FOLDROBOT", true)
                    this.$emit("hideCollect")
                }


                pubsub.publish("getQuestionList", {
                    type: robotId,
                });
            }
        },
    }
};    